// src/api/products.ts

import api from '@/lib/axios';
import type {
  Product,
  CreateProductRequest,
  UpdateProductRequest,
  ProductListResponse,
  PanelDownloadInfo,
} from '@/types/product';

/**
 * 创建产品
 * POST /v1/developer/products
 */
export const createProduct = (
  data: CreateProductRequest
): Promise<Product> => {
  return api.post('/developer/products', data);
};

/**
 * 获取产品列表（分页）
 * GET /v1/developer/products?page=1&size=20&category={category_id}
 * @param page - 页码（默认 1）
 * @param size - 每页数量（默认 20）
 * @param category - 类别 ID（可选）
 */
export const getProducts = (
  page: number = 1,
  size: number = 20,
  category?: string
): Promise<ProductListResponse> => {
  const params = new URLSearchParams();
  params.append('page', page.toString());
  params.append('size', size.toString());
  if (category) {
    params.append('category', category);
  }
  return api.get(`/developer/products?${params.toString()}`);
};

/**
 * 获取产品详情
 * GET /v1/developer/products/{product_id}
 * @param productId - 产品 ID
 */
export const getProduct = (productId: string): Promise<Product> => {
  return api.get(`/developer/products/${productId}`);
};

/**
 * 更新产品
 * PUT /v1/developer/products/{product_id}
 * @param productId - 产品 ID
 * @param updates - 更新数据
 */
export const updateProduct = (
  productId: string,
  data: UpdateProductRequest
): Promise<void> => {
  return api.put(`/developer/products/${productId}`, data);
};

/**
 * 删除产品
 * DELETE /v1/developer/products/{product_id}
 * @param productId - 产品 ID
 */
export const deleteProduct = (productId: string): Promise<void> => {
  return api.delete(`/developer/products/${productId}`);
};

/**
 * 下载产品面板（双平台）
 * GET /v1/developer/products/{product_id}/panel/download
 * @param productId - 产品 ID
 */
export const downloadProductPanel = (productId: string): Promise<PanelDownloadInfo> => {
  return api.get(`/developer/products/${productId}/panel/download`);
};